<template>
  <div class="main-right">
    <div class="header">指数趋势</div>
    <div class="block-body">
      <div class="body-top">
        <div class="btns">
          <p class="body-title fl">{{title}}发展指数趋势图</p>
          <div class="fr">
            <a-button @click="showSetparamsModel = true">参数设置</a-button>
            <a-button style="margin-left: 20px" @click="getRegionList"
              >增加对比</a-button
            >
          </div>
        </div>
        <div class="chart" ref="chart"></div>
      </div>
      <div class="body-bottom">
        <p class="body-title">{{title}}发展指数趋势列表</p>
        <!-- <a-table  :columns="columns" :data-source="data" :pagination="false">
                </a-table> -->
        <table class="tab">
          <tr v-for="(item, key) in tabData" :key="key">
            <td v-for="(i, k) in item" :key="k" :class="{'tab-weight':key == 0}">{{ i.val }}</td>
          </tr>
        </table>
      </div>
    </div>
    <a-modal
      v-model="showSetparamsModel"
      title="参数设置"
      :footer="null"
      :width="800"
      class="params-modal"
    >
      <a-row class="card-body">
        <a-col class="fl">
          <p class="title">参数设置</p>
          <div class="check-con">
            <div class="groups">
              <div class="label fl">指数选择:</div>
              <div class="itemList fl">
                <a-checkbox-group v-model="indicatorCodes">
                  <a-checkbox
                    class="checkbox"
                    v-for="(item, key) in indicatorList"
                    :key="key"
                    :value="item.indicator_code"
                    >{{ item.indicator_name_zh }}</a-checkbox
                  >
                </a-checkbox-group>
              </div>
            </div>
            <div class="groups">
              <div class="label fl">参考线:</div>
              <div class="itemList fl">
                <a-checkbox-group v-model="referenceParam">
                  <a-checkbox class="checkbox" value="pavg"
                    >省内平均值</a-checkbox
                  >
                  <a-checkbox class="checkbox" value="avg"
                    >内蒙古平均值</a-checkbox
                  >
                  <a-checkbox class="checkbox" value="pcenter"
                    >省内中位数</a-checkbox
                  >
                  <a-checkbox class="checkbox" value="center"
                    >内蒙古中位数</a-checkbox
                  >
                </a-checkbox-group>
              </div>
            </div>
          </div>
        </a-col>
        <div class="splitLine"></div>
        <a-col class="fr">
          <p class="title">指数预测</p>
          <div class="check-con">
            <div class="label fl">预测年份:</div>
            <div class="sel-year fl">
              <a-radio-group v-model="endYear">
                <a-radio
                  class="radiobox"
                  v-for="item in trendYears"
                  :key="item.value"
                  :value="item.val"
                  >{{ item.name }}</a-radio
                >
              </a-radio-group>
            </div>
          </div>
        </a-col>
      </a-row>
      <div class="btns">
        <a-button class="b1" @click="celHandler">取消</a-button>
        <a-button class="b2" @click="sucHandler">确定</a-button>
      </div>
    </a-modal>
    <a-modal
      v-model="showCityModal"
      title="请选择对比城市"
      :width="820"
      :footer="null"
      class="city-modal"
    >
      <div class="city">
        <vue-scroll :ops="ops" style="height: 100%;">
          <div class="item fl" v-for="item in regionList" :key="item.code">
            <a-radio-group v-model="compareCodes">
            <div class="name">{{ item.name }}</div>
              <a-radio class="radio-box" v-for="i in item.cityList" :key="i.code" :value="i.code" :disabled="i.code==regionCode">{{ i.name }} </a-radio>
            </a-radio-group>
            </div>
        </vue-scroll>
      </div>
      <div class="btns">
        <a-button class="b1" @click="celCityHandler">取消</a-button>
        <a-button class="b2" @click="sucCityHandler">确定</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import * as echarts from "echarts";
import config from "@/until/configs";
import _ from "loadsh"
const data = [
  {
    key: "1",
    city: "北京",
    fz: "0.1223",
    jj: "0.1234",
    sh: "0.12324",
    hj: "0.1234",
    gn: "0.1234",
    cx: "0.1234",
  },
  {
    key: "2",
    city: "上海",
    fz: "0.2223",
    jj: "0.1234",
    sh: "0.12324",
    hj: "0.1234",
    gn: "0.1234",
    cx: "0.1234",
  },
  {
    key: "3",
    city: "广东",
    fz: "0.3223",
    jj: "0.1234",
    sh: "0.12324",
    hj: "0.1234",
    gn: "0.1234",
    cx: "0.1234",
  },
];
const columns = [
  {
    title: "序号",
    dataIndex: "key",
    key: "key",
    width: 80,
  },
  {
    title: "指标名称",
    dataIndex: "city",
    key: "city",
    width: 100,
  },
  {
    title: "2010年",
    dataIndex: "fz",
    key: "fz",
  },
  {
    title: "2010年",
    dataIndex: "jj",
    key: "jj",
  },
  {
    title: "2010年",
    dataIndex: "sh",
    key: "sh",
  },
  {
    title: "2010年",
    dataIndex: "hj",
    key: "hj",
  },
  {
    title: "2010年",
    dataIndex: "gn",
    key: "gn",
  },
  {
    title: "2010年",
    dataIndex: "cx",
    key: "cx",
  },
];

const lineOption = {
  tooltip: {
    trigger: "axis",
  },
  legend: {
    type: "scroll",
  },
  grid: {
    top: "10%",
    bottom: "8%",
    left: "5%",
    right: "2%",
  },
  xAxis: {
    type: "category",
    data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    axisTick: {
      show: false, //隐藏x轴刻度
    },
  },
  yAxis: {
    type: "value",
  },
  series: [
    {
      data: [150, 230, 224, 218, 135, 147, 260],
      type: "line",
    },
  ],
};
let lineChart;
export default {
  props: ["cubeId", "regionCode",'title'],
  data() {
    return {
      data,
      columns,
      ops:config.vueScrollSetting,
      tabData: [],
      showSetparamsModel: false,
      indicatorList: [],
      trendYears: [],
      indicatorCodes: [],
      referenceParam: [],
      endYear: null,
      regionList: [],
      showCityModal: false,
      compareCodes:null,
    };
  },

  mounted() {
    lineChart = echarts.init(this.$refs.chart);
    this.getIndicatorTrend();
  },

  methods: {
    sucCityHandler(){
      this.getIndicatorTrend();
      this.showCityModal = false
    },
    celCityHandler(){
      this.compareCodes = null
      this.showCityModal = false
    },
    getRegionList() {
      if(this.regionList.length == 0){
        this.$http.getAllRegion({cubeId:this.cubeId}).then((res) => {
          if (res.success) {
            this.regionList = res.regionList;
            this.showCityModal = true;
          }
        });
      }else{
        this.showCityModal = true;
      }
    },
    celHandler() {
      this.showSetparamsModel = false;
    },
    sucHandler() {
      this.getIndicatorTrend();
      this.showSetparamsModel = false;
    },
    getIndicatorTrend() {
      console.log(this.regionCode,'regionCoderegionCoderegionCode01')

      if (!this.regionCode) return;
      console.log(this.regionCode,'regionCoderegionCoderegionCode02')
      const params = {
        cubeId: this.cubeId,
        compareCodes: this.compareCodes,
        indicatorCodes: this.indicatorCodes.join(","),
        referenceParam: this.referenceParam.join(","),
        regionCode:this.regionCode,
        endYear: this.endYear,
        flagtype: 1,
      };
      this.$http.getIndicatorTrend(params).then((res) => {
        if (res.success) {
          let series = [],
            xAxis = [];
          this.tabData = res.regionIndicatorData;

          res.regionIndicatorData[0].map((item, index) => {
            if (index > 1) {
              xAxis.push(parseFloat(item.val));
            }
          });

          res.regionTrend.forEach((item) => {
            let obj = {
              data: item.valList,
              type: "line",
              name: item.name,
            };
            series.push(obj);
          });
          
          lineChart.clear()
          const option = _.cloneDeep(lineOption)
          option.xAxis.data = xAxis;
          option.series = series;
          lineChart.setOption(option);

          this.indicatorList = res.indicatorList;
          this.indicatorCodes.push(res.indicatorList[0].indicator_code);
          this.trendYears = res.trendYears;
          this.endYear = res.trendYears[0].val;
        }
      });
    },
  },
  watch: {
    cubeId(val) {
      this.compareCodes = null
      this.indicatorCodes = []
      this.referenceParam = []
      this.getIndicatorTrend();
    },
    regionCode(val) {
      this.compareCodes = null
      this.indicatorCodes = []
      this.referenceParam = []
      console.log(val,'regionCode')
      console.log(this.regionCode,'regionCoderegionCoderegionCode')

      this.getIndicatorTrend();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/dataIndex/index.scss";
.tab {
  width: 100%;
  text-align: center;
  border-spacing: 0;
  border-collapse: unset;
  // border-top: 1px solid #000;
  // border-right: 1px solid #000;
  // border-collapse: collapse;
  th,
  td {
    // border-left: 1px solid #000;
    border-bottom: 1px solid #E8E8E8;
  }
  td {
    // border:1px solid #fff;
    height:54px;
    color: #000;
    padding: 3px 5px;
    font-size: 14px;
  }
  .alignCenter {
    text-align: center;
  }
  .tab-weight{
    font-weight:600;
    background:#FAFAFA
  }
}
</style>
<style lang="scss">
.params-modal {
  .card-body {
    .title {
      height: 16px;
      line-height: 16px;
      padding-left: 5px;
      margin-bottom: 20px;
      border-left: 2px solid #15b98c;
      color: #000;
    }
    .check-con {
      overflow: hidden;
      .groups {
        overflow: hidden;
        margin-bottom: 10px;
      }
      .label {
        width: 60px;
        text-align: right;
        font-weight: 700;
      }
      .itemList {
        width: 350px;
        .checkbox {
          width: 155px;
          margin-left: 10px;
          margin-bottom: 5px;
          color: #222;
        }
      }
      .sel-year {
        width: 240px;
        .radiobox {
          margin-left: 10px;
          margin-bottom: 5px;
          width: 100px;
        }
      }
    }
  }
  .btns {
    text-align: center;
    .b1 {
      &:hover {
        color: rgba(0, 0, 0, 0.65);
        border-color: #d9d9d9;
      }
      &:focus {
        color: rgba(0, 0, 0, 0.65);
        border-color: #d9d9d9;
      }
    }
    .b2 {
      background: #0F5743;
      border-color: #0F5743;
      color: #fff;
    }
  }
}
.city-modal {
  .city{
    height:300px;
    .item{
      width:380px;
      margin-top:10px;
      .name{
        font-size: 12px;
        font-weight: 700;
        color:#222;
      }
      .radio-box{
        width: 80px;
      }
    }
  }
  .btns {
    text-align: center;
    .b1 {
      &:hover {
        color: rgba(0, 0, 0, 0.65);
        border-color: #d9d9d9;
      }
      &:focus {
        color: rgba(0, 0, 0, 0.65);
        border-color: #d9d9d9;
      }
    }
    .b2 {
      background: #0F5743;
      border-color: #0F5743;
      color: #fff;
    }
  }
}
</style>
